import Service from '@/helpers/service'

export default {
	endUserSearchMaterial(page, params) {
		return Service().get('end-user-search-material?page=' + page, {params});
	},
	endUserSearchByCharacteristic(page, params) {
		return Service().get('end-user-search-by-characteristic?page=' + page, {params});
	},
    partCharValueEndUser(params) {
        return Service().get('part-char-value-end-user', {params});
    },
    getMaterialPlant(params) {
        return Service().get('material-plant', {params});
    },
    workBenchMaterial(params){
        return Service().get('workbench-search-material',{params})
    },
    updateWorkBenchMaterial(params,id){
        return Service().post('workbench-search-material/update/' + id, params)
    }
}
